// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"597ff5b0","110":"cf25c406"}[chunkId] + ".chunk.js";
};